<div class="company-home-employees-container">
  <div class="header">
    <div class="title">
      <div class="section-title">
        {{ "company.table-employees.title" | translate }}
        <span> {{ employeesList.length }}</span>
        <div class="add-employee">
          <cowing-button
          [label]="'company.employees.add'| translate"
          [type]="EButtonType.Rounded"
          [iconShow]="true"
          [iconName]="'addIcon'"
          (click)="newEmployee = !newEmployee"></cowing-button>
          <cowing-modal [isOpen]="newEmployee" (toggle)="toggleModal($event)"></cowing-modal>
        </div>
      </div>
    </div>
    <div class="filters-section">
      <!-- <div class="filter" [formGroup]="filterForm">
        <cowing-input-dropdown
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [control]="filterForm.get('space_id')"
          [label]="'coworker.booking.space' | translate"
          [options]="filterSpacesList"
          [type]="'object'"
        >
        </cowing-input-dropdown>
      </div>
      <div class="filter">
        <cowing-input-dropdown
          [inputStyle]="EInputStyleType.Secondary"
          [isForm]="true"
          [control]="filterForm.get('state_id')"
          [label]="'coworking-home.bookings.states' | translate"
          [options]="bookingStates"
          [type]="'object'"
        >
        </cowing-input-dropdown>
      </div> -->
    </div>
  </div>
  <div class="table-header">
    <div class="head">
      {{ "company.table-employees.table-headers.employee" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.email" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.id-employee" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.status" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.cp" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.cowings-month" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.cowings-now" | translate }}
    </div>
    <div class="head">
      {{ "company.table-employees.table-headers.actions" | translate }}
    </div>
  </div>

  <div class="table-container" *ngIf="employeesList.length">
    <div class="table" *ngFor="let employee of employeesList">
      <div class="row">
        <div>{{ employee.name }}</div>
        <div>{{ employee.email }}</div>
        <div>{{ employee.employee_id }}</div>
        <div>{{ employee.state }}</div>
        <div>{{ employee.cp }}</div>
        <div>{{ employee.total_cowings }}</div>
        <div>
          {{ employee.current_cowings }}
        </div>
        <div>
          <cowing-button
            [type]="EButtonType.iconRounded"
            (event)="deleteEmployee(employee)"
            [iconName]="'trashActive'"
            [iconShow]="true"
            [logoType]="'red'"
          ></cowing-button>
        </div>
      </div>
    </div>
    <div class="action-pagination">
      <div class="pagination">
        <img
          *ngIf="previousPage !== null"
          [src]="getLeftArrowIcon"
          alt=""
          (click)="setPreviousPage()"
        />
        <img
          *ngIf="previousPage === null"
          [src]="getDisabledLeftArrowIcon"
          alt=""
        />
        <span> {{ filterForm.get("page").value + 1 }} </span>
        <img
          *ngIf="nextPage !== null"
          [src]="getRightArrowIcon"
          alt=""
          (click)="setNextPage()"
        />
        <img
          *ngIf="nextPage === null"
          [src]="getDisabledRightArrowIcon"
          alt=""
        />
      </div>
    </div>
  </div>
  <div *ngIf="!employeesList.length" class="table-empty">
    <img [src]="getCalendarIcon" alt="" />
    <span>{{ "company.table-employees.no-employees" | translate }}</span>
  </div>
</div>
